import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/commons/Button';
import Loading from 'components/commons/Loading';
import Swal from 'sweetalert2';
import successImage from './assets/success.svg';
import './SuccessfulPurchase.scss';

const SuccessfulPurchase = (props) => {
  const { orderId, onDownloadOrderPDF, loading, whatsappNumber } = props;
  const [countdown, setCountdown] = useState(30);
  const [showCountdown, setShowCountdown] = useState(true);

  useEffect(() => {
    if (countdown <= 0) {
      setShowCountdown(false);
      redirectToWhatsApp();
      return;
    }
    const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown]);

  const isValidWhatsAppNumber = (number) => {
    const re = /^[1-9]\d{7,14}$/
    return re.test(number)
  }

  const isMobileDevice = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const redirectToWhatsApp = () => {
    setShowCountdown(false);
    if (!isValidWhatsAppNumber(whatsappNumber)) {
      Swal.fire({
        icon: 'error',
        title: 'Número de WhatsApp no disponible',
        text: 'Por favor, contacta al soporte.',
      });
      return;
    }

    const message = `Hola, Craco. Ya realicé mi pedido número #${orderId}. Quiero que se comuniquen conmigo a la brevedad para que podamos coordinar la entrega y el pago.`;
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;

    if (isMobileDevice()) {
      // App de WhatsApp en móvil
      window.location.href = url;
    } else {
      // WhatsApp Web en desktop
      window.open(url, '_blank');
    }
  };

  return (
    <div className="container" data-testid="successful-purchase-page">
      <div className="row successful-purchase flex-column justify-content-center align-items-center text-center">
        <img src={successImage} alt="successful-purchase" className="successful-purchase-check" />
        <br />
        <p className="successful-purchase-title">¡Tu pedido fue realizado con &eacute;xito!</p>
        <br />
        {showCountdown && countdown > 0 && (
          <>
            <p className="redirect-main-message">
              Redirigiendo a WhatsApp en <strong>{countdown}</strong>{' '}
              segundos.
            </p>
            <br />
          </>
        )}
        <p>
          <span>
            En pocos minutos se le estará enviando un mail a tu casilla de correo electr&oacute;nico
            {' '}
            con el detalle de tu pedido. Recordá verificar la carpeta de “SPAM” o
            “correo no deseado”.
          </span>
          <br />
          <br />
          <span>
            Tu número de pedido es #

            <span className="succesfull-orderId">{orderId}</span>
            {' '}
            ¡Es importante que lo tengas en cuenta!
          </span>
          <br />
          <br />
          <span>
            En breve nuestro equipo de ventas va a estar respondiendo tu mensaje de Whatsapp para coordinar la forma de pago y env&iacute;o.
          </span>
        </p>
        <div className="account-item-menu">
          {loading && <Loading message="Cargando..." size={80} />}
          {!loading && (
            <>
              <div className="top-nav-item-menu">
                <Button
                  onClick={redirectToWhatsApp}
                  text="Ir a WhatsApp"
                  buttonClass="button-come"
                />
              </div>
              <div className="top-nav-item-menu">
                <Button buttonClass="button-come" text="Volver al inicio" href="/home" />
              </div>
              <div className="top-nav-item-menu">
                <Button
                  onClick={() => onDownloadOrderPDF()}
                  text={(
                    <span>
                      <i className="fa fa-download" aria-hidden="true" />
                      {' '}
                      Descargar detalle
                    </span>
                  )}
                  buttonClass="button-reverse"
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

SuccessfulPurchase.propTypes = {
  orderId: PropTypes.string.isRequired,
  onDownloadOrderPDF: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
export default SuccessfulPurchase;
